import React from 'react'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const Notifisystem = () => <ToastContainer />

export default Notifisystem
